<div class="tw-absolute tw-right-5 tw-top-5 tw-flex" id="btn-close-dialog">
  <button
    class="tw-top-5 tw-size-6.5 tw-cursor-pointer tw-rounded-[50%] tw-border-2 tw-text-center tw-text-geyser hover:tw-border-battleship-gray hover:tw-text-battleship-gray"
    (click)="close()"
    data-test-id="btn-close-upload-dialog"
  >
    &#10006;
  </button>
</div>
<ia-succession-document-upload-area />
